(function () {
	'use strict';

    angular.module("imApp").factory("brRegService", ['$ihttp', function ($ihttp) {
		let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1304,
                    parameters: parms || {}
                });
            },
            listNaces: function (parms) {
                return $ihttp.post({
                    method: 1312,
                    parameters: parms || {}
                });
            },
            listCounties: function (parms) {
                return $ihttp.post({
                    method: 1307,
                    parameters: parms || {}
                });
            },
            listCommunities: function (parms) {
                return $ihttp.post({
                    method: 1308,
                    parameters: parms || {}
                });
            },
            getBrRegUrl: function (setting) {
                return $ihttp.post({
                    method: 1309,
                    parameters: setting
                });
            },
            listCompanies: function (parms) {
                return $ihttp.post({
                    method: 1305,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
